import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=5ea6043a&scoped=true&"
import script from "./properties.vue?vue&type=script&lang=js&"
export * from "./properties.vue?vue&type=script&lang=js&"
import style0 from "./properties.vue?vue&type=style&index=0&id=5ea6043a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6043a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VFlex,VLayout,VSelect,VSwitch,VTab,VTabItem,VTabs,VTabsSlider,VTextField,VTextarea})
